// extracted by mini-css-extract-plugin
module.exports = {"score":"Step3Score_score__1_ELS"};